import React from 'react';
import './Button.scss';
const Button = (props) => {
  let classes = ['btn'];
  const { action, type, className, children } = props;

  if (className) {
    classes.push(className);
  }
  switch (type) {
    case 'primary':
      classes.push('btn-primary');
      break;
    case 'btn-primary':
      classes.push('btn-primary-bg');
      break;
    case 'secondary':
      classes.push('btn-secondary');
      break;
    case 'third':
      classes.push('btn-third');
      break;
    case 'link':
      classes.push('btn-link');
      break;
    default:
      classes.push('btn-primary');
  }

  return (
    <button
      type={'button'}
      className={classes.join(' ') + ' UI-element'}
      disabled={props.disabled ? 'disabled' : null}
      onClick={action}
    >
      {children}
    </button>
  );
};

export default Button;
